import { useGetMetaTagsQuery, useUpdateMetaTagsMutation } from '../../store/services/settings';
import MetaTagsFormWrapper from '../ui/meta-tags-form-wrapper';
import { Button, Form, FormProps, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { cloneElement, useEffect } from 'react';
import { toast } from 'react-toastify';
import { TUpdateMetaTagsForm } from '../../core/types/forms/meta-tags';

const formSettings: Record<string, any> = {
  home: {
    title: 'Мета данные для главной страницы',
  },
  creators: {
    title: 'Мета данные для страницы "Креаторы"',
  },
  joinCommunity: {
    title: 'Мета данные для страницы "Вступить в комьюнити"',
  },
  contacts: {
    title: 'Мета данные для страницы "Контакты"',
  },
  license: {
    title: 'Мета данные для страницы "Пользовательское соглашение"',
  },
};

const MetaTagsForm = () => {
  const [form] = Form.useForm();
  const { data } = useGetMetaTagsQuery();
  const [updateMetaTags, { isLoading }] = useUpdateMetaTagsMutation();

  useEffect(() => {
    if (!data) {
      return;
    }
    form.setFieldsValue(data);
  }, [data]);

  const onFinish: FormProps<TUpdateMetaTagsForm>['onFinish'] = async values => {
    try {
      await updateMetaTags(values).unwrap();
      toast.success('Успешно сохранено!');
    } catch (e) {
      toast.error('Произошла ошибка');
    }
  };

  return (
    <div className={'max-w-[940px]'}>
      <Form form={form} layout={'vertical'} onFinish={onFinish}>
        {Object.keys(formSettings).map(key => {
          const titleInput = (
            <Form.Item name={`${key}MetaTitle`} label="Мета заголовок">
              <Input />
            </Form.Item>
          );

          const descriptionInput = (
            <Form.Item name={`${key}MetaDescription`} label="Мета описание" className="mb-0">
              <TextArea />
            </Form.Item>
          );

          return (
            <MetaTagsFormWrapper key={key} label={formSettings?.[key]?.title}>
              {cloneElement(<div />, {}, titleInput, descriptionInput)}
            </MetaTagsFormWrapper>
          );
        })}
        <div className={'flex justify-center'}>
          <Button loading={isLoading} type="primary" htmlType="submit">
            Сохранить
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default MetaTagsForm;
